import React from 'react';
import { useTranslation } from 'react-i18next';

const FAQSchema = () => {
  const { t } = useTranslation();
  
  const generateFAQSchema = () => {
    const faqItems = [
      { q: 'faq.q1.question', a: 'faq.q1.answer' },
      { q: 'faq.q2.question', a: 'faq.q2.answer' },
      { q: 'faq.q3.question', a: 'faq.q3.answer' },
      { q: 'faq.q4.question', a: 'faq.q4.answer' },
      { q: 'faq.q5.question', a: 'faq.q5.answer' },
      { q: 'faq.q6.question', a: 'faq.q6.answer' },
      { q: 'faq.q7.question', a: 'faq.q7.answer' },
      { q: 'faq.q8.question', a: 'faq.q8.answer' },
      { q: 'faq.q9.question', a: 'faq.q9.answer' },
      { q: 'faq.q10.question', a: 'faq.q10.answer' },
      { q: 'faq.q11.question', a: 'faq.q11.answer' },
      { q: 'faq.q12.question', a: 'faq.q12.answer' }
    ];

    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqItems.map(item => ({
        "@type": "Question",
        "name": t(item.q),
        "acceptedAnswer": {
          "@type": "Answer",
          "text": t(item.a)
        }
      }))
    };

    return JSON.stringify(schema);
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: generateFAQSchema()
      }}
    />
  );
};

export default FAQSchema; 